import { Dispatch } from 'redux'

import * as AttributeOptionApi from 'redux/api/AttributeOptions'

import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

export function tryGetAllAttributeOptions() {
  return (dispatch: Dispatch) => {
    AttributeOptionApi.getAll()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data.data))
      })
      .catch(() => {})
  }
}

export const useAttributeOptionActions = () => {
  return {
    tryGetAllAttributeOptions: useThunkActions(tryGetAllAttributeOptions)
  }
}
